'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _cssSelectorEval = require('@rexlabs/css-selector-eval');

var _cssSelectorEval2 = _interopRequireDefault(_cssSelectorEval);

var _constants = require('./utils/constants');

var _utils = require('./utils');

var _ = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PROP_TYPES = {
  styles: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  styledName: _propTypes2.default.string,
  innerRef: _propTypes2.default.func
};

/**
 * Check if a component is eligible for a ref function.
 * Useful, since React 16 throws warnings when you
 * try to pass a ref to a stateless components.
 * @param {function|Class} Component 
 */
function canHaveRef(Component) {
  return !!Component.prototype.render;
}

/**
 * Higher-Order Component that passes all props, as well as a styles utility prop, to the wrapped component.
 *
 * It combines three sources of styles for the styles utility to then consume when called.
 *
 * Layers:
 * 1. defaultStyles given as argument to styled
 * 2. styles prop given to components created by styled
 * 3. Matches from StylesProvider.
 *
 * @param {Object} [defaultStyles={}]
 *    The default styles.
 * @returns {function(React.Component)}
 *    Function to be given the desired component.
 */
function styled() {
  var defaultStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return function wrapComponentWithStyles(WrappedComponent) {
    var _class, _temp, _class$contextTypes;

    (0, _invariant2.default)(WrappedComponent, 'Must provide a Component to be wrapped');

    var displayName = _.getDisplayName(WrappedComponent);
    var wrapDispayName = 'styled(' + displayName + ')';
    if (process.env.NODE_ENV !== 'production') {
      _.warnPoorDisplayName(displayName);
    }
    var STYLES_THUNK_TRACE_OPTIONS = { traceDisplayName: displayName };

    var Styled = (_temp = _class = function (_Component) {
      (0, _inherits3.default)(Styled, _Component);
      (0, _createClass3.default)(Styled, [{
        key: 'getChildContext',
        value: function getChildContext() {
          return (0, _defineProperty3.default)({}, _constants.CONTEXT_COMPONENT_PATH, this.getComponentPath());
        }
      }]);

      function Styled(props, context) {
        var _ref2;

        (0, _classCallCheck3.default)(this, Styled);

        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        var _this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Styled.__proto__ || (0, _getPrototypeOf2.default)(Styled)).call.apply(_ref2, [this, props, context].concat(args)));

        _this.ctxEmitter = context[_constants.CONTEXT_EMITTER];
        _this.state = { stylesUtil: _this.getStylesUtil(props, context) };
        _this.handleProviderEmit = _this.handleProviderEmit.bind(_this);
        return _this;
      }

      (0, _createClass3.default)(Styled, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
          if (this.ctxEmitter) {
            this.ctxEmitter.on(this.handleProviderEmit);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (this.ctxEmitter) {
            this.ctxEmitter.off(this.handleProviderEmit);
          }
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps, nextContext) {
          var hasStylesPropChanged = nextProps.styles !== this.props.styles;
          var hasStyledNameChanged = nextProps.styledName !== this.props.styledName;
          if (hasStylesPropChanged || hasStyledNameChanged) {
            this.setState({
              stylesUtil: this.getStylesUtil(nextProps, nextContext)
            });
          }
        }
      }, {
        key: 'render',
        value: function render() {
          // Don't pass `styles` prop down the the WrappedComponent, because it's
          // a layer to use for resolution later
          var _props = this.props,
              styles = _props.styles,
              styledName = _props.styledName,
              rest = (0, _objectWithoutProperties3.default)(_props, ['styles', 'styledName']);

          var props = (0, _extends3.default)({}, rest, {
            // We add a handler for ref, so that a user of `styled` components can
            // use an 'innerRef' prop instead.
            ref: canHaveRef(WrappedComponent) ? this.callInnerRef : undefined,
            styles: this.state.stylesUtil
          });

          return (0, _react.createElement)(WrappedComponent, props);
        }

        /**
         * Handles changes to the ref of the WrappedComponent. Calls `innerRef`
         * prop when changes occur.
         * @param {*} ref
         */

      }, {
        key: 'callInnerRef',
        value: function callInnerRef(ref) {
          if (ref && ref.props && ref.props.innerRef) {
            ref.props.innerRef(ref);
          }
        }
      }, {
        key: 'getComponentName',
        value: function getComponentName(props) {
          return props.styledName || displayName;
        }
      }, {
        key: 'getComponentsStack',
        value: function getComponentsStack(props, context) {
          return [context[_constants.CONTEXT_COMPONENT_PATH] || '', this.getComponentName(props)].filter(Boolean);
        }
      }, {
        key: 'getComponentPath',
        value: function getComponentPath() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
          var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

          return this.getComponentsStack(props, context).join(_constants.COMPONENT_PATH_DELIM);
        }
      }, {
        key: 'getProviderStyles',
        value: function getProviderStyles() {
          var _this2 = this;

          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
          var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

          var emitter = context[_constants.CONTEXT_EMITTER];
          var providerStylesConfig = emitter ? emitter.data : [];
          var path = this.getComponentPath();
          var paths = path.includes(_constants.COMPONENT_PATH_DELIM) ? path.split(_constants.COMPONENT_PATH_DELIM) : [path];
          var bestSelector = (0, _keys2.default)(providerStylesConfig)
          // But we only care about selectors that target this component
          .filter(function (selector) {
            var selectorParts = selector.split(' ');
            var selectorTail = selectorParts[selectorParts.length - 1];
            return _this2.getComponentName(props) === selectorTail;
          })
          // If it has spacing, it's a css selector; check against the selector
          .filter(function (selector) {
            var hasSelectors = selector.includes(' ');
            if (hasSelectors) {
              // HACK: cssSelectorEval doesn't support selector root's that aren't
              //       also the object model root, so we force the object model to
              //       start where the selector would.
              var selectorRoot = selector.split(' ')[0];
              var pathsFromSelectorRoot = paths.slice(paths.indexOf(selectorRoot));
              var tree = {
                children: [_.treeFromPaths(pathsFromSelectorRoot)]
              };
              return (0, _cssSelectorEval2.default)(selector, tree);
            } else {
              return true;
            }
          }).reduce(function (highest, selector) {
            var selectorSpecificity = _.getSpecificity(selector);
            if (!highest) {
              return { specificity: selectorSpecificity, selector: selector };
            } else if (selectorSpecificity > highest.specificity) {
              highest.specificity = selectorSpecificity;
              highest.selector = selector;
            }
            return highest;
          }, undefined);
          if (bestSelector && bestSelector.selector) {
            return providerStylesConfig[bestSelector.selector];
          }
        }
      }, {
        key: 'getLayers',
        value: function getLayers(props, context) {
          var _layers;

          var layers = (_layers = {}, (0, _defineProperty3.default)(_layers, _constants.LAYERS.DEFAULT, defaultStyles), (0, _defineProperty3.default)(_layers, _constants.LAYERS.PROVIDER, this.getProviderStyles(props, context)), (0, _defineProperty3.default)(_layers, _constants.LAYERS.PROPS, props.styles), _layers);
          return _constants.LAYER_PRIORITY.map(function (source) {
            return layers[source];
          }).filter(_.truthy);
        }
      }, {
        key: 'getBaseStylesUtil',
        value: function getBaseStylesUtil(layers) {
          var self = this;
          // TODO: Instead of displayName, give an array of provider matches + displayName
          var layersStyles = layers.map(function (stylesObject) {
            return _.createStylesThunk(stylesObject, STYLES_THUNK_TRACE_OPTIONS);
          });

          return function styles() {
            for (var _len2 = arguments.length, names = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              names[_key2] = arguments[_key2];
            }

            var props = _.mergeStylingPropsCollection(layersStyles.map(function (styles) {
              return styles.apply(undefined, names);
            }));
            if (process.env.NODE_ENV !== 'production') {
              // Attach the path of styled components, to make developing themes
              // easier.
              props['data-styletrace'] = self.getComponentsStack(self.props, self.context).join(_constants.COMPONENT_TRACE_DELIM);
            }
            return props;
          };
        }

        /**
         * Prepares the the styles util, to be passes to wrapped components.
         * @returns {Function}
         */

      }, {
        key: 'getStylesUtil',
        value: function getStylesUtil() {
          var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
          var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.context;

          var layers = this.getLayers(props, context);
          var styles = this.getBaseStylesUtil(layers);

          styles.with = _.memoizeByClassNames(function stylesPartial() {
            for (var _len3 = arguments.length, names = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              names[_key3] = arguments[_key3];
            }

            return function stylesWith() {
              for (var _len4 = arguments.length, primitivesOrProps = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                primitivesOrProps[_key4] = arguments[_key4];
              }

              var withProps = _.flattenPrimitivesAndPropsToProps(primitivesOrProps);
              return _.mergeResolvedStylesWithProps(styles, withProps, names);
            };
          });

          return styles;
        }
      }, {
        key: 'handleProviderEmit',
        value: function handleProviderEmit() {
          this.setState({ stylesUtil: this.getStylesUtil() });
        }
      }]);
      return Styled;
    }(_react.Component), _class.WrappedComponent = WrappedComponent, _class.displayName = wrapDispayName, _class.contextTypes = (_class$contextTypes = {}, (0, _defineProperty3.default)(_class$contextTypes, _constants.CONTEXT_EMITTER, _propTypes2.default.object), (0, _defineProperty3.default)(_class$contextTypes, _constants.CONTEXT_COMPONENT_PATH, _propTypes2.default.string), _class$contextTypes), _class.childContextTypes = (0, _defineProperty3.default)({}, _constants.CONTEXT_COMPONENT_PATH, _propTypes2.default.string), _temp);


    (0, _hoistNonReactStatics2.default)(Styled, WrappedComponent);
    // NOTE: We go ahead and hoist prop types, so tools like Storybook work nicely.
    process.env.NODE_ENV !== "production" ? Styled.propTypes = (0, _assign2.default)({}, WrappedComponent.propTypes || {}, PROP_TYPES) : void 0;
    Styled.defaultProps = WrappedComponent.defaultProps;
    return Styled;
  };
}

exports.default = styled;